import React from "react";
import RegistrationSvgIcon from "./RegistrationSvgIcon";

export default function GlobalIcon({ size = 24 }) {
  const GlobalIconSVG = `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clip0_827_1468)">
<path d="M12 23C18.075 23 23 18.075 23 12C23 5.925 18.075 1 12 1M12 23C5.925 23 1 18.075 1 12C1 5.925 5.925 1 12 1M12 23C15 23 16 18 16 12C16 6 15 1 12 1M12 23C9 23 8 18 8 12C8 6 9 1 12 1M2 16H22M2 8H22" stroke="black" strokeWidth="1.6"/>
</g>
<defs>
<clipPath id="clip0_827_1468">
<rect width="24" height="24" rx="8" fill="white"/>
</clipPath>
</defs>
</svg>
`;
  return <RegistrationSvgIcon xml={GlobalIconSVG} width={size} height={size} />;
}
